import React from 'react';
import FAQ from '../components/FAQ';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { SITE_URL } from '../config/site';
import './PageStyles.css';

const FAQPage = () => {
  const { t } = useLanguage();

  return (
    <div className="page-container">
      <SEO
        title="Dental FAQ | Dr. Muyabins Dental Care Dar es Salaam"
        description="Frequently asked questions about dental appointments, treatments, insurance, and oral health at Dr. Muyabins Dental Care in Tanzania."
        keywords="dental FAQ Tanzania, dentist questions Dar es Salaam, dental appointment FAQ"
        url={`${SITE_URL}/faq`}
      />
      <PageHero
        title={t('pages.faqTitle')}
        subtitle={t('pages.faqSubtitle')}
        breadcrumb={[
          { label: 'Home', href: '/' },
          { label: 'FAQ' },
        ]}
      />
      <FAQ />
    </div>
  );
};

export default FAQPage;
